//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// This file was almost autogenerated by cuetsy.
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

export const modelVersion = Object.freeze([0, 0]);

export enum TextMode {
  HTML = 'html',
  Markdown = 'markdown',
}

export interface PanelOptions {
  content: string;
  mode: TextMode;
}

export const defaultPanelOptions: PanelOptions = {
  content: `# Title

For markdown syntax help: [commonmark.org/help](https://commonmark.org/help/)`,
  mode: TextMode.Markdown,
};
